module.exports = __webpack_public_path__ + "img/DE01592.2e14630f.png";